export default __webpack_public_path__ + "static/media/olympics-podium.5750d01a.png";